import {
  BulkUpdateOrderStatusRequest,
  CreateOrderStatusRequest,
  OrderStatus,
  OrderStatusFilters,
  OrderStatusStatistics,
  PaginatedOrderStatusResponse,
  ReorderStatusesRequest,
  StatusTransitionValidation,
  StatusValidation,
  UpdateOrderStatusRequest,
} from "../types/admin";
import { ApiResponse } from "../types/common";

import { ApiClient } from "./apiClient";

const orderStatusService = new ApiClient<OrderStatus>("/admin/order-statuses");

export const getStatusesWithFilters = (
  filters: OrderStatusFilters,
): Promise<ApiResponse<PaginatedOrderStatusResponse>> => {
  return orderStatusService.custom("get", "", undefined, { params: filters });
};

export const getStatusDetail = (
  id: number,
): Promise<ApiResponse<OrderStatus>> => {
  return orderStatusService.get(id);
};

export const createStatus = (
  request: CreateOrderStatusRequest,
): Promise<ApiResponse<OrderStatus>> => {
  return orderStatusService.create(request);
};

export const updateStatus = (
  id: number,
  request: UpdateOrderStatusRequest,
): Promise<ApiResponse<OrderStatus>> => {
  return orderStatusService.update(id, request);
};

export const deleteStatus = (id: number): Promise<ApiResponse<boolean>> => {
  return orderStatusService.custom("delete", `/${id}`);
};

export const toggleStatusActive = (
  id: number,
): Promise<ApiResponse<boolean>> => {
  return orderStatusService.custom("put", `/${id}/toggle-active`);
};

export const bulkUpdateStatusActive = (
  request: BulkUpdateOrderStatusRequest,
): Promise<ApiResponse<boolean>> => {
  return orderStatusService.custom("put", "/bulk-update-active", request);
};

export const reorderStatuses = (
  request: ReorderStatusesRequest,
): Promise<ApiResponse<boolean>> => {
  return orderStatusService.custom("put", "/reorder", request);
};

export const getStatusStatistics = (): Promise<
  ApiResponse<OrderStatusStatistics>
> => {
  return orderStatusService.custom("get", "/statistics");
};

export const validateStatus = (
  request: CreateOrderStatusRequest,
): Promise<ApiResponse<StatusValidation>> => {
  return orderStatusService.custom("post", "/validate", request);
};

export const validateStatusUpdate = (
  id: number,
  request: UpdateOrderStatusRequest,
): Promise<ApiResponse<StatusValidation>> => {
  return orderStatusService.custom("post", "/validate-update", {
    id,
    ...request,
  });
};

export const validateStatusTransition = (
  fromStatusId: number,
  toStatusId: number,
): Promise<ApiResponse<StatusTransitionValidation>> => {
  return orderStatusService.custom(
    "get",
    `/validate-transition?fromStatusId=${fromStatusId}&toStatusId=${toStatusId}`,
  );
};

// Export default service object for backward compatibility
const OrderStatusService = {
  getStatusesWithFilters,
  getStatusDetail,
  createStatus,
  updateStatus,
  deleteStatus,
  toggleStatusActive,
  bulkUpdateStatusActive,
  reorderStatuses,
  getStatusStatistics,
  validateStatus,
  validateStatusUpdate,
  validateStatusTransition,
};

export default OrderStatusService;
